/**
 * Das Banner bei Watch Frontline (GAME_DESIGN Abschnitt 13).
 *
 * Hier stand bis zum 09.10.2026 die Enemy View: ein Kasten mit Hero, Leben,
 * Mana, Portal, Tier und Creepzahl des Gegners, dazu die Druckwarnung.
 *
 * Beides ist weg, aus zwei verschiedenen Gruenden:
 *
 *   - Der Kasten zeigte Werte einer gegnerischen Lane, die es auf der
 *     gemeinsamen Lane nicht mehr gibt. Den Gegner selbst sieht man jetzt
 *     direkt im Bild.
 *   - Die Druckwarnung sitzt jetzt am Frontbalken (FrontlineBar) und ist
 *     dauerhaft sichtbar. Vorher erschien sie nur in der Enemy View - also
 *     ausgerechnet dann nicht, wenn man gerade kaempfte.
 *
 * Uebrig bleibt die Auskunft, was gerade passiert. Sie ist wichtig, weil die
 * Kamera woanders steht als der Hero und das sonst wie ein Fehler aussieht.
 */

import { t } from '../i18n/index.js';
import type { MatchSnapshot } from '../net/MatchConnection.js';

export function WatchFrontlineBanner({ snapshot }: { snapshot: MatchSnapshot }) {
  const front = snapshot.frontlines;
  const gibtEsEine = front.blue.aktiv || front.orange.aktiv;

  return (
    <div className="dl-enemy-banner">
      <span className="dl-enemy-banner__title">{t.frontline.watch}</span>
      <span className="dl-enemy-banner__sub">
        {gibtEsEine ? t.enemyView.subtitle : t.frontline.none}
      </span>
    </div>
  );
}
